import { render, staticRenderFns } from "./CardInner.vue?vue&type=template&id=6dc76abe&scoped=true&"
import script from "./CardInner.vue?vue&type=script&lang=js&"
export * from "./CardInner.vue?vue&type=script&lang=js&"
import style0 from "./CardInner.vue?vue&type=style&index=0&id=6dc76abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc76abe",
  null
  
)

export default component.exports